import { ObjectKeyProperty } from '@/backend/models/objectInstance';
import { useParameterStore } from '@/frontend/store/ParameterStore';
import { I18n } from '@/i18n/I18n';
import { UpdatedParamsAndRefs } from '@/types/parameterTypes';
import { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';

export function ObjectKeyInput(props: {
  property: ObjectKeyProperty,
  properties: ObjectKeyProperty[],
  handleUpdatedConsumers: (response: UpdatedParamsAndRefs) => void,
  keyLabel?: string,
}) {
  const { property, properties, handleUpdatedConsumers, keyLabel } = props;
  const updateObjectKey = useParameterStore(state => state.updateObjectKey);
  const [key, setKey] = useState(property.key);
  const [keyError, setKeyError] = useState('');

  useEffect(() => {
    setKey(property.key);
  }, [property.key]);

  const onKeyChange = (newKey: string) => {
    setKey(newKey);
    const existingKey = properties.find(prop => prop.key === newKey && prop.keyId !== property.keyId);
    if (existingKey) {
      setKeyError(I18n.get('uniqueObjectKeyError'));
    } else {
      setKeyError('');
    }
  };

  const onKeyBlur = () => {
    if (!keyError) {
      void updateObjectKey({ ...property, id: property.keyId, name: key }, handleUpdatedConsumers);
    }
  };

  const finalKeyLabel = keyLabel || I18n.get('identifier');

  return (
    <div className='flex-fill w-100'>
      <Form.Label className="form-label-neutral">{finalKeyLabel} ({I18n.get(property.type)})</Form.Label>
      <Form.Control
        size='sm'
        aria-label={I18n.get('enterField', { field: finalKeyLabel })}
        value={key}
        type='text'
        onChange={(e) => onKeyChange(e.target.value)}
        onBlur={onKeyBlur}
        isInvalid={!!keyError}
        className="form-control-neutral"
        />
        <Form.Control.Feedback type="invalid">
          { keyError }
        </Form.Control.Feedback>
    </div>
  );
}
